import { mapState } from "vuex";

/**
 *   全局注入公共的数据变量
 */
export default {
  computed: {
    ...mapState({
      // 品牌列表
      globalBrands: (state) => state.window.globalBrands,
    }),
  },
};
